module.exports = __webpack_public_path__ + "static/media/shoppingCart.c283acd7.svg";